"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SearchResult = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var task_1 = require("./task");
var task_project_1 = require("./task-project");
var app_1 = require("./app");
var person_1 = require("./person");
var chat_1 = require("./chat");
var sprint_1 = require("./sprint");
var person_action_1 = require("./person-action");
var task_project_planning_1 = require("./task-project-planning");
var task_project_create_task_1 = require("./task-project-create-task");
var task_project_kanban_1 = require("./task-project-kanban");
var sprint_kanban_1 = require("./sprint-kanban");
var sprint_planning_1 = require("./sprint-planning");
var stuff_asset_1 = require("./stuff-asset");
var chat_message_1 = require("./chat-message");
var team_1 = require("./team");
var mail_message_1 = require("./mail-message");
var stuff_container_1 = require("./stuff-container");
var react_native_1 = require("react-native");
exports.SearchResult = react_1["default"].memo(function SearchResult(props) {
    var resultProps = react_1["default"].useMemo(function () { return ({
        index: props.index,
        result: props.result,
        onClose: props.onClose,
        onUpdateResults: props.onUpdateResults,
        overrideOnClick: props.overrideOnClick
    }); }, [
        props.index,
        props.onClose,
        props.onUpdateResults,
        props.overrideOnClick,
        props.result,
    ]);
    if (props.result.type === 'stuff/container') {
        return ((0, jsx_runtime_1.jsx)(stuff_container_1.StuffContainerSearchResult, __assign({}, resultProps)));
    }
    if (props.result.type === 'tasks/task') {
        return ((0, jsx_runtime_1.jsx)(task_1.TaskSearchResult, { index: props.index, result: props.result, onClose: props.onClose, overrideOnClick: props.overrideOnClick }));
    }
    if (props.result.type === 'tasks/project') {
        return ((0, jsx_runtime_1.jsx)(task_project_1.TaskProjectSearchResult, { index: props.index, result: props.result, onClose: props.onClose, onUpdateResults: props.onUpdateResults }));
    }
    if (props.result.type === 'app') {
        return ((0, jsx_runtime_1.jsx)(app_1.AppSearchResult, { index: props.index, result: props.result, onClose: props.onClose }));
    }
    if (props.result.type === 'person') {
        return ((0, jsx_runtime_1.jsx)(person_1.PersonSearchResult, __assign({}, resultProps)));
    }
    if (props.result.type === 'stuff/asset') {
        return ((0, jsx_runtime_1.jsx)(stuff_asset_1.StuffAssetSearchResult, __assign({}, resultProps)));
    }
    if (props.result.type === 'organization/team') {
        return ((0, jsx_runtime_1.jsx)(team_1.OrganizationTeamSearchResult, __assign({}, resultProps)));
    }
    if (props.result.type === 'person/action') {
        return ((0, jsx_runtime_1.jsx)(person_action_1.PersonActionSearchResult, { index: props.index, result: props.result, onClose: props.onClose, onUpdateResults: props.onUpdateResults }));
    }
    if (props.result.type === 'tasks/project-planning') {
        return ((0, jsx_runtime_1.jsx)(task_project_planning_1.TaskProjectPlanning, { index: props.index, result: props.result, onClose: props.onClose, onUpdateResults: props.onUpdateResults }));
    }
    if (props.result.type === 'tasks/project/create-task') {
        return ((0, jsx_runtime_1.jsx)(task_project_create_task_1.TaskProjectCreateTask, { index: props.index, result: props.result, onClose: props.onClose, onUpdateResults: props.onUpdateResults }));
    }
    if (props.result.type === 'tasks/project/kanban') {
        return ((0, jsx_runtime_1.jsx)(task_project_kanban_1.TaskProjectKanban, { index: props.index, result: props.result, onClose: props.onClose, onUpdateResults: props.onUpdateResults }));
    }
    if (props.result.type === 'mail/message') {
        return ((0, jsx_runtime_1.jsx)(mail_message_1.MailMessageResult, { index: props.index, result: props.result, onClose: props.onClose, onUpdateResults: props.onUpdateResults }));
    }
    if (props.result.type === 'chat/chat') {
        return ((0, jsx_runtime_1.jsx)(chat_1.ChatSearchResult, { index: props.index, result: props.result, onClose: props.onClose }));
    }
    if (props.result.type === 'tasks/sprint') {
        return ((0, jsx_runtime_1.jsx)(sprint_1.SprintSearchResult, __assign({}, resultProps)));
    }
    if (props.result.type === 'tasks/sprint.kanban') {
        return ((0, jsx_runtime_1.jsx)(sprint_kanban_1.SprintKanbanSearchResult, __assign({}, resultProps)));
    }
    if (props.result.type === 'tasks/sprint.planning') {
        return ((0, jsx_runtime_1.jsx)(sprint_planning_1.SprintPlanningSearchResult, __assign({}, resultProps)));
    }
    if (props.result.type === 'chat/message') {
        return ((0, jsx_runtime_1.jsx)(chat_message_1.ChatMessageResult, __assign({}, resultProps)));
    }
    return (0, jsx_runtime_1.jsx)(react_native_1.View, {});
});
